import PropTypes from 'prop-types';
export const formErrorTextPropTypes = {
  /**
   * Text Message as string
   */
  children: PropTypes.node,
  /**
   * Additional classname
   */
  classname: PropTypes.string
};